import React from 'react'
import { Form, Dropdown } from 'stylist'
import displayName from 'utils/displayName'
import { Global, css } from '@emotion/core'

const globalStyles = css`
  ul[id^='downshift-'] {
    z-index: 99999 !important;
  }
`

const DropdownField = ({
  field,
  key,
  twoFAEnabled,
  value,
  setValue,
  values,
  options,
}) => {
  if (!twoFAEnabled) return null

  const changeValue = (value) => {
    const currentValues = values.filter((v) => v.name !== field.name)
    currentValues.push({
      name: field.name,
      value,
    })
    setValue(currentValues)
  }

  return (
    <React.Fragment>
      <Global styles={globalStyles} />
      <Form.Group>
        <label>{field.label || displayName(field.name)}:</label>
        <Dropdown
          key={key}
          name={field.name}
          value={value}
          onChange={(v) => changeValue(v)}
        >
          {options.map((o, index) => (
            <Dropdown.Option key={index} value={o.value}>{o.text}</Dropdown.Option>
          ))}
        </Dropdown>
      </Form.Group>
    </React.Fragment>
  )
}

export default DropdownField



// WEBPACK FOOTER //
// ./src/components/fields/Dropdown.js